import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H1: Components["h1"] = ({ children, className, ...rest }) => (
  <h1
    className={cn("af-m-0 af-pt-6 af-text-2xl af-font-bold", className)}
    {...rest}
  >
    {children}
  </h1>
);
